import React from 'react'
import './chips.css'

const Chip = ({ onRemove, children, index }) => {
  return (
    <div className="chipContainer">
      {children}
      <span className="onRemove" onClick={() => onRemove(index) }>&times;</span>
    </div>
  );
}

export default Chip;
